import React, { useState } from "react";
import styles from "./styles/styled-dropdown.module.scss";

type Props = {
  currentValue: string;
  values: string[];
  onChanged: (value: string) => void;
};

const Dropdown = ({ currentValue, values, onChanged }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (value: string) => {
    onChanged(value);
    setIsOpen(false);
  };

  return (
    <div className={styles.dropdown}>
      <button
        className={`${styles.dropdownToggle} ${isOpen ? styles.open : ""}`}
        onClick={toggleDropdown}
      >
        {currentValue}
        <span
          className={`${styles.dropdownArrow} ${isOpen ? styles.up : styles.down}`}
        ></span>
      </button>
      {isOpen && (
        <ul className={styles.dropdownMenu}>
          <li className={styles.dropdownSeparator}>
            <hr />
          </li>
          {values.map((option, index) => (
            <li
              key={index}
              className={`${styles.dropdownOption} ${currentValue === option ? styles.selected : ""}`}
              onClick={() => handleOptionClick(option)}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
